// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__37xw4","dealershipSpecific":"Nav_dealershipSpecific__ckmG1"};